import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
export function ImpressumPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="py-16 md:py-24 bg-white" data-id="element-441">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-442">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-vita-green-deep mb-12" data-id="element-443">
          Impressum
        </h1>

        <div className="space-y-10 text-vita-text-muted leading-relaxed" data-id="element-444">
          <div data-id="element-445">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-446">
              Angaben gemäß § 5 TMG
            </h2>
            <p data-id="element-447">
              Nuviora UG (haftungsbeschränkt) Cosimastraße 121 München, 81925
              Deutschland
            </p>
            <p className="mt-4" data-id="element-448">Geschäftsführer: Khoanh Nam Ta</p>
          </div>

          <div data-id="element-449">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-450">
              Kontakt
            </h2>
            <p data-id="element-451">E-Mail: info@vitafrukt.de</p>
          </div>

          <div data-id="element-452">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-453">
              Registereintrag
            </h2>
            <p data-id="element-454">
              Eintragung im Handelsregister. Handelsregister: HRB 306058
              Registergericht: Amtsgericht München
            </p>
          </div>

          <div data-id="element-455">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-456">
              Umsatzsteuer-ID
            </h2>
            <p data-id="element-457">
              Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:
              DE457899389
            </p>
          </div>

          <div data-id="element-458">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-459">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p data-id="element-460">
              Nuviora UG (haftungsbeschränkt) Cosimastraße 121 München, 81925
              Deutschland
            </p>
          </div>

          <div className="pt-6 border-t border-vita-border" data-id="element-461">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-462">
              Haftung für Inhalte
            </h2>
            <p data-id="element-463">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-4" data-id="element-464">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
              Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
            </p>
          </div>

          <div data-id="element-465">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-466">
              Urheberrecht
            </h2>
            <p data-id="element-467">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}